import { render, staticRenderFns } from "./failedCard.vue?vue&type=template&id=561b760c&scoped=true"
import script from "./failedCard.vue?vue&type=script&lang=js"
export * from "./failedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b760c",
  null
  
)

export default component.exports